<template>
  <v-app id="HeaderItem">
    <v-app-bar
      app
      clipped-left
      color="grey lighten-3"
      class="px-0"
    >
      <v-img
        class="mx-1"
        src="../images/weplat.png"
        max-height="45"
        max-width="102"
      />
      <v-toolbar-title style="color: #3F51B5">
        クラウドフォルダー{{ header_env }}
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
  </v-app>
</template>

<script>
import AppConfig from '../app_config.json';

export default {
    data: () => ({
    header_env: AppConfig.header_env,
  }),
};
</script>

<style>
</style>